module.exports = __webpack_public_path__ + "img/5.153ba650.jpg";